import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useAuth } from 'hooks/useAuth';
import { handleUnauthenticated } from 'utils/authHelpers';
import LoadingIndicator from 'ui/LoadingIndicator';
import { useHistory } from 'react-router-dom';

const RequireAuth = ({ children }) => {
  const { isLoading, isAuthenticated, loginWithRedirect } = useAuth();
  const history = useHistory();

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      handleUnauthenticated(loginWithRedirect, history);
    }
  }, [isLoading, isAuthenticated, loginWithRedirect, history]);

  if (isLoading || !isAuthenticated) {
    return <LoadingIndicator cover />;
  }

  return children;
};

RequireAuth.propTypes = {
  children: PropTypes.node.isRequired
};

export default RequireAuth;
